import React from 'react';
import { CAMP_TYPES, DRAGGABLE_WINDOWS, MANUAL_MESSAGES_STATUS, UNIFIED_INBOX_PERMISSIONS } from '../../constants.js';
import { SingletonSharedData } from '../singletonSharedData';
import notificationWhatsappSound from '../../audios/dry-pop-up-notification.wav';
import { AgentButton } from 'global-components-library';
const audio = new Audio(notificationWhatsappSound);
import _ from 'lodash';
import { Singleton } from '../Singleton';

const sharedData = new SingletonSharedData();
const language = new Singleton();

const deleteConvsWhatsapp = (message, that) => {
	const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
	if(hasUnifiedMessage){
		that.props.endConversationsCampaignDeleted(message);
	}
}

export const STRATEGIES_EXTERNAL_MESSAGING = {
	"EXTERNAL_MESSAGING_CUSTOMER": function (message, that) {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if (hasUnifiedMessage) {
			if (sharedData.currentState !== 'Dialog' &&
				sharedData.currentState !== 'Wrapup' &&
				sharedData.currentState !== 'Assisted' &&
				sharedData.currentState !== 'Other') {
					that.props.showUnifiedMessagesWindow(true);
			}else{
				sharedData.setIsPendingMessage(true);
			}
			if(!sharedData.getIsTabFocused()){
				audio.play();}


			if( _.has(message, 'externalMessagingCustomerDto.OldConversationID') && message.externalMessagingCustomerDto.OldConversationID !== 0 
			&& _.has(message, 'externalMessagingCustomerDto.OldAgentId') && message.externalMessagingCustomerDto.OldAgentId === sharedData.user.User_id 
			&& message.externalMessagingCustomerDto.CampType !== CAMP_TYPES.OUT && message.externalMessagingCustomerDto.IsAgentLoggingOut === false){
				that.props.showAdminModal({
					title: that.language.getText('GUIUnifiedInboxnoMoreAgentsAlertTitle'),
					content: that.language.getText('GUIUnifiedInboxnoMoreAgentsAlertMessage'),
					accept: that.language.getText('GUIUnifiedInboxCommonclose')
				})
			}

			that.props.newUnifiedInboxExternalMessage(message, that);

		}
	},
	"EXTERNAL_NEW_MESSAGING": function (message, that) {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if (hasUnifiedMessage) {
			that.props.newUnifiedInboxExternalNewMessage(message);

			if(!sharedData.getIsTabFocused()){
				audio.play();}
		}
		
	},
	"MULTIMEDIA_MESSAGE_STATUS": function (message,that) {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if (hasUnifiedMessage) {
			that.props.changeStateMessage(message);
		}
	},
	"MULTIMEDIA_MESSAGE_TIMEOUT_CLIENT": (message, that)=> {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if(hasUnifiedMessage){
			that.props.conversationTimeoutReached(message);
		}
	},
	"MULTIMEDIA_MESSAGE_ERROR_MMC": (message, that)=> {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if(hasUnifiedMessage){
			that.props.alertMessageErrorMMC(message);
			if (message.value) {
				sharedData.setPrevNotificationError(message.value);
				that.showDialogBox({
					title: language.getText("GUIUnifiedInboxTitleAlertErrorMCS"),
					content: language.getText("GUIUnifiedInboxBodyAlertErrorMCS"),
					accept: language.getText("GUIUnifiedInboxAceptAlertErrorMCS")
				})

			} else {
				if(sharedData.getPrevNotificationError()){
					sharedData.setPrevNotificationError(false);
					that.props.addToast(language.getText('GUIUnifiedInboxBodyAlertSuccessMCS'), {
						group: 'icon', 
						position: 'topRight',
						icon: 'warning', 
						color: 'yellow', 
						btnComponent: <AgentButton type='tertiary'>{language.getText("GUIUnifiedInboxAceptAlertSuccessMCS")}</AgentButton>,
						timeout: 5000
					});
				}
			}
		}
	},
	"DELETE_WA_CAMPAIGN": (message, that) =>  {
		deleteConvsWhatsapp(message, that)
	},
	"MULTIMEDIA_END_CONVERSATIONWA_ERROR": (message, that) => {
		deleteConvsWhatsapp(message, that)
	},
	"MULTIMEDIA_MESSAGE_HISTORICAL_CHAT": (message, that)=> {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if(hasUnifiedMessage){
			if(message.Data.ResponseCode === 200) {
				that.props.newHistoricalConversation(message);
			} else {
				that.props.errorOnHistoricalConversation(message);
				that.showDialogBox({
					title: language.getText("GUIUnifiedInboxlastConversationErrorTitle"),
					content: language.getText("error-8003"),
					accept: language.getText("GUIUnifiedInboxlastConversationErrorCommit"),
				})
			}
		}
	},
	"UPDATE_PERMISSION": (message, that) => {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if(hasUnifiedMessage){
			const permissionTitle = message.PermissionValue ? that.language.getText('GUIUnifiedInboxPermissionGrantedTitle') : that.language.getText('GUIUnifiedInboxPermissionRemovedTitle');

			//TODO: Faltan mensajes para permiso SPAM
			let permissionBody = '';
			if(message.PermissionName === UNIFIED_INBOX_PERMISSIONS.AllowUnassign){
				permissionBody = message.PermissionValue ? that.language.getText('GUIUnifiedInboxPermissionGrantedBody') : that.language.getText('GUIUnifiedInboxPermissionRemovedBody');
			}

			if(permissionBody){
				that.props.showAdminModal({
					title: permissionTitle,
					content: permissionBody,
					accept: that.language.getText('GUIUnifiedInboxPermissionMssgsCommit')
				})
			}
			

			that.props.updatePermissions(message.PermissionName, message.PermissionValue)
		}
	},
	"MULTIMEDIA_UPDATE_NUMBERWA_TO_CONVERSATIONS": (message, that) => {
		const hasUnifiedMessage = that.sharedData.generalPermissions[220] === '1';
		if(hasUnifiedMessage){
			that.props.updateConversationsPhoneChange(message);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_External_Messaging.js